import ActionTypes from '../constants/ActionTypes';
import { isSiteLoaded } from '../selectors/sites';
import { Dispatch } from 'redux';
import { State } from '../reducers';
import Site from '../interfaces/site';
import { supo, tradieApi } from '../api';
import { isSiteAbnLoaded } from '../selectors/sitesAbn';

export const fetchSite = (key: number) => {
  return async (dispatch: Dispatch, getState: () => State) => {
    if (isSiteLoaded(getState(), key)) return;
    try {
      const { data: site }: { data: Site } = await supo.get(`/sites/${key}`);

      return dispatch({
        type: ActionTypes.FETCH_SITE_SUCCESS,
        payload: { site, key },
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_SITE_NOT_FOUND,
          payload: { key },
          error,
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_SITE_ERROR,
        payload: { key },
        error,
      });
    }
  };
};

export const fetchSiteHasValidAbn = (key: string) => {
  return async (dispatch: Dispatch, getState: () => State) => {
    if (isSiteAbnLoaded(getState(), key)) return;
    try {
      const { data } = await tradieApi.get(`/profile/${key}/has-valid-abn`);
      const abnInfo = data.data;
      return dispatch({
        type: ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_SUCCESS,
        payload: {
          key: key,
          hasValidAbn: abnInfo.hasValidAbn,
          redirectOnInvalidAbn: abnInfo.redirectOnInvalidAbn,
        },
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_NOT_FOUND,
          payload: { key },
          error,
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_ERROR,
        payload: { key },
        error,
      });
    }
  };
};
